import { graphql } from 'react-relay';

export default graphql`
  query EventPage_Query($eventId: String, $trinityPartyId: String) {
    viewer {
      id
      ...EventPage_viewer
        @arguments(eventId: $eventId, trinityPartyId: $trinityPartyId)
    }
  }
`;
